import React, { Component } from "react";
import { Button, } from "antd";

import "./ColumnLink.less";

export default class ColumnLink extends Component {
  render() {
    return (
      <Button
        type="link"
        size="small"
        {...this.props}
      >
        {this.props.children}
        {this.props.value && this.props.value}
      </Button>
    );
  };
};
